export default "__VITE_ASSET__CZ9FzzJf__"